import { DOCUMENT } from '@angular/common';
import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, Router } from '@angular/router';
import { WINDOW } from '@personal-area/common';
import { BehaviorSubject, Observable, filter, fromEvent } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class NavigationControllerService {

  public sidebarVisible: Observable<boolean>;

  private _sidebarVisible = new BehaviorSubject<boolean>(false);
  private _renderer: Renderer2;

  constructor(
    private _router: Router,
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private _document: Document,
    @Inject(WINDOW) private _window: Window,
  ) {
    this.sidebarVisible = this._sidebarVisible.asObservable();
    this._renderer = rendererFactory.createRenderer(null, null);

    this._router.events
      .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
      .subscribe(this.hideSidebar)

    fromEvent(this._window, 'resize')
      .pipe(
        filter(() => this._document.body.offsetWidth > 1260 && this._sidebarVisible.value),
      )
      .subscribe(this.hideSidebar);
  }

  public showSidebar = () => {
    this._renderer.addClass(this._document.querySelector('.page-wrapper'), 'no-overflow'); // for iOS Safari
    this._renderer.addClass(this._document.body, 'no-overflow');
    this._renderer.addClass(document.querySelector('.page-wrapper'), 'mobile-no-overflow');
    if (this._document.body.offsetWidth > 544) {
      this._document.documentElement.style.setProperty('--navigation-height', `100vh`);
    } else {
      this._document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
      this._document.documentElement.style.setProperty('--navigation-height', `${this._window.innerHeight}px`);
    }
    this._sidebarVisible.next(true);
  }

  public hideSidebar = () => {
    this._renderer.removeClass(this._document.body, 'no-overflow');
    this._renderer.removeClass(this._document.querySelector('.page-wrapper'), 'no-overflow');
    this._renderer.removeClass(this._document.querySelector('.page-wrapper'), 'mobile-no-overflow');
    this._sidebarVisible.next(false);
  }
}
